import React from 'react';
import PropTypes from 'prop-types';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function RedoButton({ content, onClick, disabled }) {
  return (
    <CPButton
      title="Повернути"
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faRedo}
    />
  );
}

RedoButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

RedoButton.defaultProps = {
  onClick: () => null,
  content: 'Повернути',
  disabled: false,
};

export default RedoButton;
